"use strict";
exports.__esModule = true;
var IssueList = /** @class */ (function () {
    function IssueList() {
        this.DEFAULT = [];
    }
    IssueList.prototype.getValues = function () {
        // To check memory initializations
        console.log(this.DESIRABILITY);
        console.log(this.FEASIBILITY);
        console.log(this.VIABILITY);
        console.log(this.STRENGTHS);
        console.log(this.WEAKNESSES);
        console.log(this.OPPORTUNITIES);
        console.log(this.THREATS);
        console.log(this.HARD_ST);
        console.log(this.MEDIUM_ST);
        console.log(this.EASY_ST);
        console.log(this.VALUES);
        console.log(this.DEFAULT);
    };
    return IssueList;
}());
exports.IssueList = IssueList;
var IssueListEnum;
(function (IssueListEnum) {
    IssueListEnum[IssueListEnum["DEFAULT"] = 0] = "DEFAULT";
    IssueListEnum[IssueListEnum["DFV"] = 1] = "DFV";
    IssueListEnum[IssueListEnum["SWOT"] = 2] = "SWOT";
    IssueListEnum[IssueListEnum["ABILITY_TO_LAUNCH"] = 3] = "ABILITY_TO_LAUNCH";
    IssueListEnum[IssueListEnum["ST_UNCERT"] = 4] = "ST_UNCERT";
    IssueListEnum[IssueListEnum["NONE"] = 5] = "NONE";
    IssueListEnum[IssueListEnum["INPUT_SCREEN"] = 6] = "INPUT_SCREEN";
    IssueListEnum[IssueListEnum["N_COL_CANVAS"] = 7] = "N_COL_CANVAS";
})(IssueListEnum = exports.IssueListEnum || (exports.IssueListEnum = {}));
//# sourceMappingURL=issue-list.js.map


// WEBPACK FOOTER //
// ./app/components/utils/issue-list/issue-list.js